module.exports = "/images/vendor/flag-icon-css/flags/4x3/ml.svg?e6f097f93a69b28225c43e25fdcaf709";